import { dictionary, locale, _, init } from "svelte-i18n";
import { derived } from "svelte/store";

const MESSAGE_FILE_URL_TEMPLATE = "/assets/language/{locale}.json";

init({
  fallbackLocale: "en",
  initialLocale: "en",
});

function setupI18n({ withLocale: _locale } = { withLocale: "en" }) {
  const messsagesFileUrl = MESSAGE_FILE_URL_TEMPLATE.replace(
    "{locale}",
    _locale
  );

  return fetch(messsagesFileUrl)
    .then((response) => {
      return response.json();
    })

    .then((messages) => {
      dictionary.set({ [_locale]: messages });
      locale.set(_locale);
    });
}

const isLocaleLoaded = derived(
  locale,
  ($locale) => typeof $locale === "string"
);

export { _, setupI18n, isLocaleLoaded };